export const SERVICE_TYPE = {
  PRODUCTION: 'Production',
  PLANNED: 'Planned',
  DEPRECATED: 'Deprecated',
};
